import { alpha, Box, Button, IconButton, styled } from '@mui/material';

export const PaginationContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  borderRadius: 5,
  height: '29px',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
}));

export const PaginationButton = styled(Button)(({ theme }) => ({
  boxShadow: 'none',
  padding: theme.spacing(3),
  minWidth: '24px',
  backgroundColor: theme.palette.background.tertiary,
  border: 'none',
  '&:hover': {
    boxShadow: `0px 1px 10px ${theme.palette.primary.main}`,
  },
  '&:active': {
    boxShadow: `0px 1px 10px ${theme.palette.primary.main}`,
  },
  '&:disabled': {
    color: alpha(theme.palette.primary.main, 0.2),
  },
}));

export const PreviewContainer = styled(Box)(({ theme }) => ({
  overflow: 'hidden',
  position: 'relative',
  width: '94px',
  height: '94px',
  border: `2px solid ${theme.palette.border.tertiary}`,
}));

export const RemoveButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignContent: 'center',
  justifyContent: 'center',
  position: 'absolute',
  width: '24px',
  height: '24px',
  top: '2px',
  right: '2px',
  borderRadius: '50%',
  border: `1px solid ${theme.palette.border.tertiary}`,
  backgroundColor: theme.palette.background.main,
  '&:hover': {
    boxShadow: `0px 1px 10px ${theme.palette.primary.main}`,
  },
}));

export const RemoveButton = styled(IconButton)({
  '> img': {
    width: '12px',
    height: '12px',
  },
});

export const PageNumberContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  color: theme.palette.primary.main,
  fontWeight: 400,
  fontSize: theme.typography.textSm.fontSize,
  lineHeight: '100%',
  letterSpacing: '0%',
}));

export const HorizontalLine = styled('span')(({ theme }) => ({
  borderTop: `0.5px solid ${theme.palette.primary.main}`,
  marginLeft: theme.spacing(3),
  marginRight: theme.spacing(3),
  width: 35.55,
}));
